<forge-text-field [invalid]="isInvalid" density="small" required>
    <input #input [type]="fieldType" [autocomplete]="autocomplete" [name]="controlName" [formControl]="formControl">

    <label *ngIf="!hideLabel" [for]="controlName">
        {{label}}
    </label>

    <forge-icon-button slot="end" dense (click)="onVisibilityClick($event)" aria-label="show password">
        <forge-icon [name]="visibilityIcon"></forge-icon>
        <forge-tooltip>{{visibilityTooltip}}</forge-tooltip>
    </forge-icon-button>

    <forge-icon *ngIf="isCapsLockOn" slot="end" name="alert_circle_outline">
        <forge-tooltip>CAPS lock is on</forge-tooltip>
    </forge-icon>

    <span slot="support-text-end" *ngIf="isCapsLockOn">CAPS lock is on</span>

    <span slot="support-text" class="error">
        <ng-container *ngIf="showErrorMessage('required')">
            {{label}} is required
        </ng-container>

        <ng-container *ngIf="hasCustomValidators">
            <ng-container *ngFor="let customError of customErrors">
                <ng-container *ngIf="showErrorMessage(customError.errorKey)">
                    {{customError.message}}
                </ng-container>
            </ng-container>
        </ng-container>
    </span>
</forge-text-field>